import { DashboardOverview } from '@planbord/planbord/dashboard/pages';

export default [
  {
    path: '',
    redirect: '/overview',
  },
  {
    path: '/overview',
    component: DashboardOverview,
    name: 'overview',
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    redirect: '/overview',
  },
];
